module.exports = __webpack_public_path__ + "resources/img/zoom-ui-your-app-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-your-app-logo.png
// module id = 1372
// module chunks = 0